import { faBackward, faChevronDown, faChevronUp, faEdit, faForward, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Modal } from '@material-ui/core';
import { API, Auth } from 'aws-amplify';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ChangeEvent, SyntheticEvent, useEffect, useRef, useState } from 'react';
import { Form, ModalBody, ModalFooter, ProgressBar, Spinner } from 'react-bootstrap';
import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import FormControl from 'react-bootstrap/FormControl';
import InputGroup from 'react-bootstrap/InputGroup';
import Row from 'react-bootstrap/Row';
import { connect, useSelector } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { v4 as uuidv4 } from 'uuid';
import Content from '../components/Content';
import HistoryModal from '../components/Document/SimpleEditor/HistoryModal';
import SimpleEditor from '../components/Document/SimpleEditor/SimpleEditor';
import ConfirmationModal from '../components/Documents/ConfirmationModal';
import { fetchedDocument, startFetchingDocument, startPublishingDocument, startUpdatingDocument } from '../redux/actions';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { RootState } from '../redux/store';
import { DocumentType, ImagesOfDocument, UserData } from '../types/AppTypes';
import { deleteImages, fetchPodcasts, publishDocument, updateDocument, updateDocumentVoice } from '../utils/api';
import { getExtensionOfFile, sortArrayAtoZ } from '../utils/utils';
import { prosodyRateValues, voices } from '../utils/voices-data';
import { createXmlFile } from '../utils/xml-creator';

const downloadBlob = (blobUrl: string, filename: string) => {
  // this document points to the document object!!
  // DO NOT MOVE INTO COMPONENT
  const link = document.createElement('a');
  link.download = filename;
  link.href = blobUrl;
  document.body.appendChild(link);
  link.click();
  link.remove();
};
interface DispatchProps {
  startFetchingDocument: () => void;
  startPublishingDocument: () => void;
  startUpdatingDocument: () => void;
  fetchedDocument: (
    document: any | null,
    message?: string,
    error?: boolean,
  ) => {
    type: string;
    payload: {
      document: any | null;
      message?: string;
      error?: boolean;
    };
  };
}

interface Props {
  documents: DocumentType[];
  text: string;
  error: boolean;
  message: string;
  loading: boolean;
}

interface VoiceSettingsProps {
  domains: string[];
  engines: string[];
  gender: string;
  provider: string;
  voiceId: string;
}

interface VoiceAlertProps {
  show: boolean;
  variant: 'success' | 'danger';
  message: string;
}

type ComposedProps = Props & DispatchProps & RouteComponentProps<{ id: string }>;

const Document = (props: ComposedProps): JSX.Element => {
  const currentDocuments = useAppSelector((state) => state.documents.filteredDocuments);
  const selectedDocuments = currentDocuments ? currentDocuments.filter((d) => d.documentId === props.match.params.id) : [];
  const documentState = selectedDocuments.length > 0 ? selectedDocuments[0] : {};

  const customersListJson = process.env.REACT_APP_CUSTOMER_IDS_URL;
  const [customerIds] = useState(process.env.REACT_APP_CUSTOMER_IDS?.split(', ')!);
  const { podcasts } = useAppSelector((state) => state.podcasts);

  const dispatch = useAppDispatch();

  const [document, setDocument] = useState(documentState);
  const [inputA, setInputA] = useState(documentState.text);
  const [inputB, setInputB] = useState(documentState.text);
  const [type, setType] = useState('words');
  const [showAlert, setShowAlert] = useState(false);
  const [voiceAlert, setVoiceAlert] = useState<VoiceAlertProps>({
    show: false,
    variant: 'danger',
    message: '',
  });
  const [mp3Url, setMp3Url] = useState<string | undefined>(undefined);
  const [loading, setLoading] = useState(true);
  const [showDiffs, setShowDiffs] = useState(false);
  const [responseLanguage, setResponseLanguage] = useState(document?.speechParams?.languageCode);
  const [initialLanguage, setInitialLanguage] = useState(document?.speechParams?.languageCode);
  const [initTime, setInitTime] = useState(0);
  const [isExpanded, setIsExpanded] = useState(false);
  const [voiceSettings, setVoiceSettings] = useState<VoiceSettingsProps[]>([]);
  const [voiceBtnDisabled, setVoiceBtnDisabled] = useState<boolean>(true);
  const [voiceValues, setVoiceValues] = useState({ voiceId: '', engine: '', domain: '', prosodyRate: 0 });
  const [initialVoiceValues, setInitialVoiceValues] = useState({ voiceId: '', engine: '', domain: '', prosodyRate: 0 });
  const [externalUrlA, setExternalUrlA] = useState('');
  const [externalUrlB, setExternalUrlB] = useState('');
  const [buttonStatus, setButtonStatus] = useState<boolean>(true);
  const [updatingText, setUpdatingText] = useState<boolean>(false);
  const [voiceUpdating, setVoiceUpdating] = useState<boolean>(false);
  //update file
  const [uploading, setUploading] = useState<boolean>(false);
  const [selectedPdfFile, setSelectedPdfFile] = useState<File | null>(null);
  const [selectedMp3, setSelectedMp3] = useState<File | null>(null);
  const [uploadingMp3, setUploadingMp3] = useState(false);
  const uploadMp3 = useRef<HTMLInputElement>(null);
  const uploadPdf = useRef<HTMLInputElement>(null);
  const [responseSignedMp3Url, setResponseSignedMp3Url] = useState('');
  const [openMp3Modal, setOpenMp3Modal] = useState(false);
  const [fileButtonStatus, setFileButtonStatus] = useState(true);
  const [images, setImages] = useState<ImagesOfDocument[]>([]);
  const [indexOfImage, setIndexOfImage] = useState(0);
  const [desc, setDesc] = useState<string | undefined>();
  const [validDesc, setValidDesc] = useState(true);
  const [title, setTitle] = useState<string>();
  const [validTitle, setValidTitle] = useState(true);
  const [openHistoryModal, setOpenHistoryModal] = useState(false);
  const [year, setYear] = useState<number | undefined>();
  const [validYear, setValidYear] = useState(true);
  const [location, setLocation] = useState<string | undefined>();
  const [author, setAuthor] = useState<string | undefined>();
  const [publisher, setPublisher] = useState<string | undefined>();
  const [authorEditable, setAuthorEditable] = useState(true);
  const [yearEditable, setYearEditable] = useState(true);
  const [locationEditable, setLocationEditable] = useState(true);
  const [descEditable, setDescEditable] = useState(true);
  const [publisherEditable, setPublisherEditable] = useState(true);

  const [buttonStatusTitle, setButtonStatusTitle] = useState<boolean>(true);
  const [buttonStatusDesc, setButtonStatusDesc] = useState<boolean>(true);
  const [buttonStatusYear, setButtonStatusYear] = useState<boolean>(true);
  const [buttonStatusPublisher, setButtonStatusPublisher] = useState<boolean>(true);
  const [buttonStatusLoc, setButtonStatusLoc] = useState<boolean>(true);
  const [buttonStatusAuth, setButtonStatusAuth] = useState<boolean>(true);

  const [isCopyExpanded, setIsCopyExpanded] = useState<boolean>(false);
  const [copyInProgress, setCopyInProgress] = useState<boolean>(false);
  const [reqvaluedocId, setReqvaluedocId] = useState(false);
  const [reqvaluecustId, setReqvaluecustId] = useState(false);
  const [validated, setValidated] = useState(false);
  const [alertVariant, setAlertVariant] = useState('success');
  const [message, setMessage] = useState('');

  const [docId, setDocId] = useState<any>(props.match.params.id);
  const [disableBack, setDisableBack] = useState(false);
  const [disableForw, setDisableForw] = useState(false);
  const [comeFromCreateDoc, setComeFromCreateDoc] = useState(false);
  const [indexToDelete, setIndexToDelete] = useState(0);
  const [imageId, setImageId] = useState<string>('');
  const [showModalConfirmation, setShowModalConfirmation] = useState(false);

  const user = useSelector((state: RootState) => state.documents.user) as UserData;

  const languageVoiceRef = useRef<HTMLSelectElement>(null);
  const voiceIdRef = useRef<HTMLSelectElement>(null);
  const enginesRef = useRef<HTMLSelectElement>(null);
  const domainsRef = useRef<HTMLSelectElement>(null);
  const speakingRateRef = useRef<HTMLSelectElement>(null);
  const inputAuthorRef = useRef<any>(null);
  const inputYearRef = useRef<any>(null);
  const inputLocationRef = useRef<any>(null);
  const inputDescRef = useRef<any>(null);
  const inputPublisherRef = useRef<any>(null);
  const documentId = useRef<HTMLInputElement>(null);
  const customerId = useRef<HTMLSelectElement>(null);

  const [loadingData, setLoadingData] = useState(false);
  const [buttonClicked, setButtonClicked] = useState<'forward' | 'backward'>('forward');

  const ArrowIcon = () => {
    if (isExpanded) {
      return <FontAwesomeIcon icon={faChevronUp} />;
    }
    return <FontAwesomeIcon icon={faChevronDown} />;
  };

  const ArrowIconCopyDoc = () => {
    if (isCopyExpanded) {
      return <FontAwesomeIcon icon={faChevronUp} />;
    }
    return <FontAwesomeIcon icon={faChevronDown} />;
  };

  const checkValuesChanges = () => {
    if (initialVoiceValues.domain === '') {
      initialVoiceValues.domain = 'empty';
    }
    if (
      initialVoiceValues.domain !== voiceValues.domain ||
      initialVoiceValues.engine !== voiceValues.engine ||
      initialVoiceValues.voiceId !== voiceValues.voiceId ||
      initialVoiceValues.prosodyRate !== voiceValues.prosodyRate
    ) {
      setVoiceBtnDisabled(false);
    } else {
      setVoiceBtnDisabled(true);
    }
  };

  const getData = async (documentId: string) => {
    const apiName = 'Columbia';
    const path = `/document/${documentId}`;

    setLoadingData(true);

    /*if (document?.documentId && inputB) {
      return;
    }*/

    props.startFetchingDocument();
    const response = await API.get(apiName, path, 'abc');

    if (response) {
      setMp3Url(
        `${process.env.REACT_APP_MP3_SERVER_URL}${documentId}.mp3?userId=${user.email}&ch=dashboard&sch=web-dashboard`,
      );
      setDocument(response);
      setImages(response.imageDetails);
      const lastIndexOfImage: number | undefined = response.imageDetails?.reduce(
        (maxIndex: number, currentObject: { name: string }) => {
          const currentIndex = parseInt(currentObject.name.substring(5), 10);
          return Math.max(maxIndex, currentIndex);
        },
        -1,
      );
      if (lastIndexOfImage !== undefined && lastIndexOfImage !== -1) {
        setIndexOfImage(lastIndexOfImage);
      }
      setInputA(response.text);
      setInputB(response.text);
      setDocId(response.documentId);
      setLoading(false);
      setResponseLanguage(response.speechParams.languageCode);
      setInitialLanguage(response.speechParams.languageCode);

      const item = voices[response.speechParams.languageCode].filter(
        (item) => item.voiceId === response.speechParams.voiceId,
      );

      setVoiceSettings(item);
      setInitialVoiceValues({
        voiceId: response.speechParams.voiceId,
        domain: response.speechParams.domain,
        engine: response.speechParams.engine,
        prosodyRate: response.speechParams.prosodyRate,
      });
      props.fetchedDocument(response);
      setExternalUrlA(response.externalUrl);
      setExternalUrlB(response.externalUrl);
    } else {
      setLoading(false);
    }

    setLoadingData(false);
  };

  const onTextChange = (text: string) => {
    setInputB(text);
    if (text !== '' && inputA !== text) {
      setButtonStatus(false);
    } else {
      setButtonStatus(true);
    }
  };

  const onInputTypeChange = (e: SyntheticEvent) => {
    setType((e.target as HTMLInputElement).value);
  };

  const onInputExternalUrlChange = (e: SyntheticEvent) => {
    externalUrlA === (e.target as HTMLInputElement).value ? setButtonStatus(true) : setButtonStatus(false);
    setExternalUrlB((e.target as HTMLInputElement).value);
  };

  const isStringEmptyOrWhitespace = (inputString) => {
    if (inputString != '' && inputString != undefined) {
      return inputString.trim().length === 0;
    } else {
      return true;
    }
  };

  const onUpdate = async () => {
    setShowAlert(false);

    // updateFile()

    if (isStringEmptyOrWhitespace(title) || isStringEmptyOrWhitespace(desc) || !validYear) {
      return;
    }

    props.startUpdatingDocument();
    const text = inputB;
    const externalUrl = externalUrlB;
    let imagesInfo: ImagesOfDocument[] = [];
    images?.map((image) =>
      imagesInfo.push({
        id: image.id,
        name: image.name,
        width: image.width,
        height: image.height,
      }),
    );
    setUpdatingText(true);
    await updateFile();
    await updateDocument(
      docId,
      text,
      externalUrl,
      imagesInfo.length > 0,
      imagesInfo,
      title,
      desc,
      year,
      location,
      author,
      publisher,
    )
      .then((response) => {
        setAlertVariant('success');
        setMessage('Started document update');
        setShowAlert(true);
        setInputA(text);
        setDocument({ ...document, state: 'PENDING' });
        setUpdatingText(false);
        setTitle(response?.title);
        setDesc(response?.description);
        setAuthor(response?.author);
        setYear(response?.publicationYear);
        setLocation(response?.publicationLocation);
        setPublisher(response?.publisher);
        if (response.imageDetails?.length > 0) {
          response.imageDetails.map((image: { name: string; url: string }) => {
            images?.map((img) => {
              if (img.file) {
                if (image.name === img.name && img.id === undefined) {
                  uploadFileToS3(image.url, img.file, 'png');
                }
              }
            });
          });
        }

        setImages((prevImages) =>
          prevImages.map((image) => {
            const matchingImageDetail = response.imageDetails.find((details) => details.name === image.name);
            if (matchingImageDetail) {
              return {
                ...image,
                id: matchingImageDetail.id,
              };
            }
            return image;
          }),
        );
      })
      .catch((error) => {
        setAlertVariant('danger');
        setMessage('Failed to update document');
        setShowAlert(true);
        setUpdatingText(false);
      });
  };

  const onDownloadAudio = (url: string) => {
    fetch(url)
      .then((res) => res.blob())
      .then((blob) => {
        const blobUrl = window.URL.createObjectURL(blob);
        downloadBlob(blobUrl, `audio-${document?.documentId}`);
      })
      .catch((err) => console.error(err));
  };

  const onUpdateVoiceSettings = async () => {
    setVoiceUpdating(true);
    try {
      let domain;
      if (voiceValues.domain === 'empty') {
        domain = '';
      } else {
        domain = voiceValues.domain;
      }
      const speechParams = {
        engine: voiceValues.engine,
        languageCode: responseLanguage,
        prosodyRate: voiceValues.prosodyRate,
        provider: voiceSettings[0].provider,
        sampleRate: 24000,
        voiceId: voiceValues.voiceId,
        domain: domain,
      };

      const response = await updateDocumentVoice(docId, speechParams);
      const data = await response;
      if (data) {
        const message = 'Voice settings have successfully updated.';
        setVoiceAlert({ show: true, variant: 'success', message: message });
        setDocument(data);
        const item = voices[response.speechParams.languageCode].filter(
          (item) => item.voiceId === response.speechParams.voiceId,
        );
        setVoiceSettings(item);
        setInitialVoiceValues({
          voiceId: response.speechParams.voiceId,
          domain: response.speechParams.domain,
          engine: response.speechParams.engine,
          prosodyRate: response.speechParams.prosodyRate,
        });
        setVoiceBtnDisabled(true);
      }
      setVoiceUpdating(false);
    } catch (error: any) {
      const message = 'Voice settings update failed.';
      setVoiceAlert({ show: true, variant: 'danger', message: message });
      setVoiceUpdating(false);
    }
  };

  const onPublish = async () => {
    setShowAlert(false);
    props.startPublishingDocument();

    publishDocument(docId)
      .then((response) => {
        setAlertVariant('success');
        setMessage('Document published');
        setShowAlert(true);
        setDocument({ ...document, state: 'PUBLISHED' });
      })
      .catch((error) => {
        setAlertVariant('danger');
        setMessage('Failed to publish document');
        setShowAlert(true);
      });
  };

  const handleMp3Change = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files && files.length > 0) {
      const selected = files[0];
      if (selected.name.endsWith('.mp3')) {
        // await new Promise(resolve => setTimeout(resolve, 2000)); // Replace with actual processing logic
        setSelectedMp3(selected);
      } else {
        // Handle error: Display a message to the user that only MP3 files are allowed
        console.error('Only MP3 files are allowed.');
      }
    }
  };

  const handleRemoveMp3 = () => {
    setSelectedMp3(null);
    if (uploadMp3.current) {
      uploadMp3.current.value = '';
    }
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files && files.length > 0) {
      setSelectedPdfFile(files[0]);
      setFileButtonStatus(false);
    }
  };

  const handleRemoveFile = () => {
    setFileButtonStatus(true);
    setSelectedPdfFile(null);
    if (uploadPdf.current) {
      uploadPdf.current.value = '';
    }
  };

  const renderMP3Upload = () => {
    return (
      <>
        <Form.Group controlId="uploadMP3">
          <Form.Label>Upload MP3</Form.Label>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <FormControl type="file" ref={uploadMp3} onChange={handleMp3Change} accept=".mp3" />
            {selectedMp3 ? (
              <InputGroup.Append>
                <span
                  onClick={handleRemoveMp3}
                  style={{ padding: '2px 8px', backgroundColor: '#fafafa', cursor: 'pointer' }}
                >
                  <FontAwesomeIcon icon={faTimes} color="red" />
                </span>
              </InputGroup.Append>
            ) : (
              <></>
            )}
          </div>
        </Form.Group>
        {/* <Form.Control.Feedback
          type="invalid"
          style={{
            display: `${reqvalueMp3 ? 'block' : 'none'}`,
          }}
        >
          Please select a mp3 file.
        </Form.Control.Feedback> */}
      </>
    );
  };

  const renderPDFUpload = () => {
    return (
      <>
        <div>
          <span style={{ fontWeight: 600 }}>Current PDF Url: </span>
          {document?.pdfUrl !== '' ? document?.pdfUrl : 'No URL'}
        </div>
        <Form.Group style={{ marginTop: '5px' }} controlId="uploadPdf">
          <Form.Label style={{ fontWeight: 600 }}>Upload PDF</Form.Label>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Form.Control type="file" ref={uploadPdf} onChange={handleFileChange} style={{ width: 'auto' }} accept=".pdf" />
            {selectedPdfFile && (
              <InputGroup.Append>
                <span
                  onClick={handleRemoveFile}
                  style={{ padding: '2px 8px', backgroundColor: '#fafafa', cursor: 'pointer' }}
                >
                  <FontAwesomeIcon icon={faTimes} color="red" />
                </span>
              </InputGroup.Append>
            )}
          </div>
        </Form.Group>
      </>
    );
  };

  const handleCloseMp3Modal = () => {
    setOpenMp3Modal(false);
    setSelectedMp3(null);
  };

  const updateFile = async () => {
    if (document?.isDocFromMp3) {
      if (!selectedMp3) {
        return;
      }
    }

    //call put
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${(await Auth.currentSession()).getAccessToken().getJwtToken()}`);
    myHeaders.append('Content-Type', 'application/json');
    let json = { updateMp3: true, updatePdf: false };
    if (selectedPdfFile) {
      json.updateMp3 = false;
      json.updatePdf = true;
    }

    const requestOptions = {
      method: 'PUT',
      headers: myHeaders,
      body: json,
      redirect: 'follow',
    };

    const apiName = 'Columbia';
    const path = `/document/${document?.documentId}`;

    setUploading(true);
    await API.put(apiName, path, requestOptions)
      .then((response) => {
        setUploading(false);
        if (response.mp3SignedUrl && selectedMp3) {
          setResponseSignedMp3Url(response.mp3SignedUrl);
          setOpenMp3Modal(true);
          setUploadingMp3(true);
          uploadFileToS3(response.mp3SignedUrl, selectedMp3, 'mp3');
        }
        if (response.pdfSignedUrl && selectedPdfFile) {
          setResponseSignedMp3Url(response.mp3SignedUrl);
          setOpenMp3Modal(true);
          setUploadingMp3(true);
          uploadFileToS3(response.pdfSignedUrl, selectedPdfFile, 'pdf');
        }
      })
      .catch((error) => {
        setSelectedPdfFile(null);
        setSelectedMp3(null);
        setUploading(false);
      });
  };

  const uploadFileToS3 = async (signedUrl: string, file: File, extension: string) => {
    const myHeaders = new Headers();
    const formData = new FormData();
    let data: any;
    if (extension === 'png') {
      myHeaders.append('Content-Type', file.type);
      data = file;
    } else {
      myHeaders.append('Content-Type', 'multipart/form-data');
      formData.append(extension, file);
      data = formData;
    }

    try {
      const response = await fetch(signedUrl, {
        method: 'PUT',
        body: data,
        headers: myHeaders,
        redirect: 'follow',
      });

      setUploadingMp3(false);
      setSelectedPdfFile(null);
      setSelectedMp3(null);
      return 'SUCCESS';
    } catch (error) {
      console.error('Error uploading file:', error);
      setUploadingMp3(false);
      setSelectedPdfFile(null);
      setSelectedMp3(null);
      return 'ERROR';
    }
  };

  function changeFileName(file: File, newFileName: string): File {
    return new File([file], newFileName, { type: file.type });
  }

  const handleImageChange = async (event: ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;

    let ext: string = '';
    if (files) {
      const newFiles = Array.from(files);
      let index = indexOfImage;
      const newImages = await Promise.all(
        newFiles.map(async (file) => {
          console.log(file);
          ext = getExtensionOfFile(file.name);
          console.log(ext);
          index++;
          setIndexOfImage(index);
          const newFile = changeFileName(file, `image${index}.${ext}`);
          const src = URL.createObjectURL(newFile);

          try {
            const imageBitmap = await createImageBitmap(newFile);
            const newImage: ImagesOfDocument = {
              id: undefined,
              name: newFile.name,
              url: src,
              file: newFile,
              width: imageBitmap.width,
              height: imageBitmap.height,
            };
            return newImage;
          } catch (error) {
            console.error('Error getting image dimensions:', error);
            return null; // or handle the error in another way
          }
        }),
      );

      const filteredNewImages = newImages.filter((image) => image !== null) as ImagesOfDocument[];

      setImages((prevImages) => [...prevImages, ...filteredNewImages]);
    }
  };

  const handleImageRemove = (index: number, imageIdToDelete: any) => {
    setImageId(imageIdToDelete);
    setIndexToDelete(index);
    setShowModalConfirmation((curr) => !curr);
  };

  const onConfirmationDelete = async () => {
    const updateImages = () => {
      const updatedFiles = [...images];
      updatedFiles.splice(indexToDelete, 1);
      setImages(updatedFiles);
    };

    if (imageId) {
      deleteImages(imageId, props.match.params.id)
        .then((res) => {
          console.log('image deleted');
          console.log(res);
          updateImages();
        })
        .catch((error: any) => {
          console.log('errorOnDeleteImage', error.message);
        })
        .finally(() => {
          setShowModalConfirmation(false);
        });
    } else {
      updateImages();
      setShowModalConfirmation(false);
    }
  };

  const onModalToggle = () => {
    setShowModalConfirmation((curr) => !curr);
  };

  const handleChangeTitle = (e) => {
    setTitle(e.target.value);
    if (e.target.value !== '' && e.target.value !== document?.title) {
      setButtonStatusTitle(false);
      setValidTitle(true);
    } else if (e.target.value === '') {
      setValidTitle(false);
      setButtonStatusTitle(true);
    } else {
      setValidTitle(true);
      setButtonStatusTitle(true);
    }
  };

  const handleChangeDescription = (e) => {
    setDesc(e.target.value);
    if (e.target.value !== '' && e.target.value !== document?.description) {
      setButtonStatusDesc(false);
      setValidDesc(true);
    } else if (e.target.value === '') {
      setValidDesc(false);
      setButtonStatusDesc(true);
    } else {
      setValidDesc(true);
      setButtonStatusDesc(true);
    }
  };

  const handleChangeYear = (e) => {
    const inputYear = e.target.value;
    const isValidYear = /^\d{4}$|^$/.test(inputYear);
    setYear(inputYear);
    setValidYear(isValidYear);
    if (isValidYear && parseInt(inputYear, 10) !== document?.publicationYear) {
      setButtonStatusYear(false);
    } else {
      setButtonStatusYear(true);
    }
  };

  const handleChangePublisher = (e) => {
    setPublisher(e.target.value);
    if (e.target.value !== document?.publisher) {
      setButtonStatusPublisher(false);
    } else {
      setButtonStatusPublisher(true);
    }
  };

  const handleChangeLocation = (e) => {
    setLocation(e.target.value);
    if (e.target.value !== document?.publicationLocation) {
      setButtonStatusLoc(false);
    } else {
      setButtonStatusLoc(true);
    }
  };

  const handleChangeAuthor = (e) => {
    setAuthor(e.target.value);
    if (e.target.value !== document?.author) {
      setButtonStatusAuth(false);
    } else {
      setButtonStatusAuth(true);
    }
  };

  const generateUID = async () => {
    const node = documentId.current;
    if (node) {
      node.value = uuidv4();
    }
  };

  const sortPodcastIdArray = () => {
    if (podcasts && podcasts.length > 0) {
      const editablePodcastIdArray = [...podcasts];
      sortArrayAtoZ(editablePodcastIdArray);
      return editablePodcastIdArray;
    }
    return undefined;
  };

  const handleCustomerOnChange = () => {
    setReqvaluecustId(false);
  };

  const onCopyDocument = async () => {
    const documentNode = documentId.current;
    const customerNode = customerId.current;
    const regexpDocumentId = new RegExp(/^[a-zA-Z0-9_-]+$/gi);

    if (documentNode && customerNode) {
      setShowAlert(false);
      if (documentNode.value === null || documentNode.value.trim() === '') {
        setReqvaluedocId(true);
        return;
      } else if (!regexpDocumentId.test(documentNode.value)) {
        setValidated(true);
        return;
      } else {
        setReqvaluedocId(false);
        setValidated(false);
      }

      if (customerNode.value === null || customerNode.value === '0') {
        setReqvaluecustId(true);
        return;
      } else {
        setReqvaluecustId(false);
      }
      const pollyParams = document?.speechParams ? JSON.stringify(document?.speechParams) : null;
      const myHeaders = new Headers();
      myHeaders.append('Authorization', `Bearer ${(await Auth.currentSession()).getAccessToken().getJwtToken()}`);
      let formdata = new FormData();

      formdata.append('documentId', documentNode.value);
      formdata.append('customerId', customerNode.value);
      formdata.append(
        'xml',
        createXmlFile(
          document?.language || '',
          title || '',
          author,
          inputB || '',
          desc || '',
          externalUrlB,
          year?.toString(),
          location,
          publisher,
        ),
        'ms3.xml',
      );
      formdata.append('externalMp3FileExists', document?.isDocFromMp3!.toString());
      if (pollyParams !== null) {
        formdata.append('pollyParams', pollyParams);
      }
      formdata.append('sourceDocumentId', docId);

      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow',
      };

      const apiName = 'Columbia';
      const path = '/document';

      setCopyInProgress(true);
      await API.post(apiName, path, requestOptions)
        .then((response) => {
          documentNode.value = '';
          customerNode.value = '0';
          setAlertVariant('success');
          setMessage('Started copy document');
          setShowAlert(true);
          setCopyInProgress(false);
        })
        .catch((error) => {
          setAlertVariant('danger');
          setMessage('Failed to copy document');
          setShowAlert(true);
          setCopyInProgress(false);
        });
    }
  };

  const goToDoc = (opt: 'next' | 'previous') => {
    console.log(currentDocuments);
    const allDocs = currentDocuments;
    const lengthDocs = allDocs?.length;
    const currentIndex = allDocs?.findIndex((item) => item.documentId === docId);
    console.log(currentIndex);

    if (opt === 'next') {
      setButtonClicked('forward');
    } else {
      setButtonClicked('backward');
    }

    if (currentIndex !== -1) {
      if (opt === 'next' && lengthDocs !== currentIndex + 1) {
        getData(allDocs[currentIndex + 1].documentId);
        if (currentIndex + 1 === lengthDocs - 1) {
          setDisableBack(false);
          setDisableForw(true);
        } else {
          setDisableBack(false);
          setDisableForw(false);
        }
      } else if (opt === 'previous' && currentIndex !== 0) {
        getData(allDocs[currentIndex - 1].documentId);
        if (currentIndex === 1 && !comeFromCreateDoc) {
          setDisableBack(true);
          setDisableForw(false);
        } else {
          setDisableBack(false);
          setDisableForw(false);
        }
      } else if (opt === 'previous' && currentIndex === 0) {
        getData(props.match.params.id);
        setDisableBack(true);
        setDisableForw(false);
      }
    } else {
      if (opt === 'next' && lengthDocs > 0) {
        getData(allDocs[0].documentId);
        if (lengthDocs === 1) {
          setDisableBack(false);
          setDisableForw(true);
        } else {
          setDisableBack(false);
          setDisableForw(false);
        }
      } else if (opt === 'previous') {
        getData(props.match.params.id);
        setDisableBack(true);
        setDisableForw(false);
      }
    }
  };

  useEffect(() => {
    const allDocs = currentDocuments;
    const lengthDocs = allDocs?.length;
    const currentIndex = allDocs?.findIndex((item) => item.documentId === docId);
    if (currentIndex === -1) {
      setComeFromCreateDoc(true);
      setDisableBack(true);
      setDisableForw(true);
    } else {
      setDisableBack(currentIndex === 0);
      setDisableForw(currentIndex === lengthDocs - 1);
    }
  }, []);

  useEffect(() => {
    setTitle(document?.title);
    setDesc(document?.description);
    setAuthor(document?.author);
    setYear(document?.publicationYear);
    setLocation(document?.publicationLocation);
    setPublisher(document?.publisher);
  }, [document]);

  useEffect(() => {
    if (user) {
      getData(docId);
    }
  }, [user]);

  useEffect(() => {
    if (responseLanguage && responseLanguage === initialLanguage && initTime === 0) {
      const item = voices[responseLanguage].filter((item) => item.voiceId === document.speechParams?.voiceId);
      setVoiceSettings(item);
      setInitTime(1);
    }
  }, [responseLanguage]);

  useEffect(() => {
    if (voiceIdRef.current !== null && voiceIdRef.current !== undefined) {
      voiceIdRef.current.value = voiceSettings[0].voiceId;
    }
    if (domainsRef.current !== null && domainsRef.current !== undefined && document.speechParams !== undefined) {
      if (document.speechParams.domain === '') {
        domainsRef.current.value = 'empty';
      } else if (voiceSettings.length > 0) {
        domainsRef.current.value = voiceSettings[0].domains[0] || '';
      } else {
        domainsRef.current.value = document.speechParams.domain;
      }
    }
    if (enginesRef.current !== null && enginesRef.current !== undefined && document.speechParams !== undefined) {
      if (voiceSettings.length > 0) {
        enginesRef.current.value = voiceSettings[0].engines[0] || '';
      } else {
        enginesRef.current.value = document.speechParams.engine;
      }
    }
    if (speakingRateRef.current !== null && speakingRateRef.current !== undefined && document.speechParams !== undefined) {
      speakingRateRef.current.value = document.speechParams.prosodyRate.toString();
    }

    if (voiceIdRef.current && domainsRef.current && enginesRef.current && speakingRateRef.current) {
      setVoiceValues({
        voiceId: voiceIdRef.current.value,
        domain: domainsRef.current.value,
        engine: enginesRef.current.value,
        prosodyRate: parseInt(speakingRateRef.current.value),
      });
    }
  }, [initialVoiceValues, voiceSettings]);

  useEffect(() => {
    if (voiceIdRef.current && domainsRef.current && enginesRef.current && speakingRateRef.current && isExpanded) {
      const domain = initialVoiceValues.domain === '' ? 'empty' : initialVoiceValues.domain;
      if (
        voiceValues.voiceId === '' ||
        voiceValues.domain === '' ||
        voiceValues.engine === '' ||
        voiceValues.prosodyRate === 0
      ) {
        setVoiceValues({
          voiceId: initialVoiceValues.voiceId,
          engine: initialVoiceValues.engine,
          domain: domain,
          prosodyRate: initialVoiceValues.prosodyRate,
        });
      }
      voiceIdRef.current.value = voiceValues.voiceId === '' ? initialVoiceValues.voiceId : voiceValues.voiceId;
      domainsRef.current.value = voiceValues.domain === '' ? domain : voiceValues.domain;
      enginesRef.current.value = voiceValues.engine === '' ? initialVoiceValues.engine : voiceValues.engine;
      speakingRateRef.current.value =
        voiceValues.prosodyRate === 0 ? initialVoiceValues.prosodyRate.toString() : voiceValues.prosodyRate.toString();
    }
  }, [isExpanded]);

  useEffect(() => {
    if (voiceValues.voiceId !== '' && initialVoiceValues.voiceId !== '') {
      checkValuesChanges();
    }
  }, [voiceValues]);

  useEffect(() => {
    if (!authorEditable) {
      inputAuthorRef?.current?.focus();
    }
  }, [authorEditable]);

  useEffect(() => {
    if (!yearEditable) {
      inputYearRef?.current?.focus();
    }
  }, [yearEditable]);

  useEffect(() => {
    if (!locationEditable) {
      inputLocationRef?.current?.focus();
    }
  }, [locationEditable]);

  useEffect(() => {
    if (!descEditable) {
      inputDescRef?.current?.focus();
    }
  }, [descEditable]);

  useEffect(() => {
    if (!publisherEditable) {
      inputPublisherRef?.current?.focus();
    }
  }, [publisherEditable]);

  useEffect(() => {
    if (customersListJson && customersListJson.startsWith('http')) {
      fetchPodcasts(dispatch);
    }
  }, []);

  if (props.error && inputB) {
    return (
      <div className="error">
        <span>{props.message}</span>
      </div>
    );
  }

  return (
    <Content loading={loading}>
      {showAlert && (
        <Alert variant={alertVariant} style={{ zIndex: 1 }} dismissible onClose={() => setShowAlert(false)}>
          {message}
        </Alert>
      )}
      <div>
        <div style={{ display: 'flex' }}>
          <div>
            <Button
              type="success"
              style={{ marginRight: '5px' }}
              onClick={() => goToDoc('previous')}
              disabled={disableBack || (loadingData && buttonClicked === 'backward')}
            >
              {loadingData && buttonClicked === 'backward' ? (
                <Spinner
                  as="span"
                  animation="grow"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  style={{ marginRight: '4px' }}
                />
              ) : (
                <FontAwesomeIcon icon={faBackward} />
              )}
            </Button>
          </div>
          <div>
            <Button
              type="success"
              onClick={() => goToDoc('next')}
              disabled={disableForw || (loadingData && buttonClicked === 'forward')}
            >
              {loadingData && buttonClicked === 'forward' ? (
                <Spinner
                  as="span"
                  animation="grow"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  style={{ marginRight: '4px' }}
                />
              ) : (
                <FontAwesomeIcon icon={faForward} />
              )}
            </Button>
          </div>
          <div style={{ marginLeft: 'auto' }}>
            <Button type="success" onClick={() => setOpenHistoryModal(true)}>
              History
            </Button>
          </div>
        </div>
        <div className="diff-container">
          <div className="column">
            <SimpleEditor
              initialText={inputB}
              document={document}
              onChange={onTextChange}
              mp3Url={mp3Url}
              onPublish={onPublish}
              onDownloadAudio={onDownloadAudio}
              handleImageChange={handleImageChange}
              handleImageRemove={handleImageRemove}
              images={images}
              handleChangeTitle={handleChangeTitle}
              validTitle={validTitle}
              title={title}
              docId={docId}
            />
            <Form.Control.Feedback
              type="invalid"
              style={{
                display: `${inputB === '' ? 'block' : 'none'}`,
              }}
            >
              Please type the content of the file.
            </Form.Control.Feedback>
            <Row className="mt-3">
              <Col className="col-xl-8 col-md-12">
                <InputGroup>
                  <div>
                    {document?.isDocFromMp3 ? (
                      renderMP3Upload()
                    ) : document?.pdfUrl !== '' ? (
                      renderPDFUpload()
                    ) : !document?.isDocFromMp3 && document?.pdfUrl === '' && document?.externalUrl === undefined ? (
                      renderPDFUpload()
                    ) : (
                      <></>
                    )}
                  </div>
                </InputGroup>
              </Col>
            </Row>
          </div>
          <div className={[showDiffs ? 'expanded' : 'hidden'].join(' ')}>
            <div className="diff-settings">
              <label>
                <input name="type" type="radio" value="chars" onChange={onInputTypeChange} />
                chars
              </label>
              <label>
                <input name="type" type="radio" value="words" defaultChecked={true} onChange={onInputTypeChange} />
                words
              </label>
              <label>
                <input name="type" type="radio" value="sentences" onChange={onInputTypeChange} />
                sentences
              </label>
            </div>
            {/* <Diff inputA={inputA} inputB={inputB} type={type} /> */}
          </div>
          {/* <div style={{ position: 'absolute', right: '0' }}>
            <CustomButton type="transparent" onClick={() => setShowDiffs(!showDiffs)}>
              {showDiffs ? 'Hide' : 'Show'} differences
            </CustomButton>
          </div> */}
        </div>
        {externalUrlB && externalUrlB !== '' && (
          <div>
            <Form.Group controlId="externalUrl" style={{ width: '50%', marginTop: '10px' }}>
              <Form.Label>External Url</Form.Label>
              <Form.Control as="input" value={externalUrlB} onChange={onInputExternalUrlChange} />
            </Form.Group>
          </div>
        )}
      </div>
      <Row style={{ width: '50%', marginLeft: '0', marginRight: '15px' }}>
        <Col>
          <Form.Group className="mb-3 mt-2" controlId="authorId">
            <Form.Label className="mr-2 mb-0" style={{ fontWeight: 600 }}>
              Authors
            </Form.Label>
            <div className="d-flex align-items-center">
              <Form.Control
                ref={inputAuthorRef}
                as="input"
                value={author}
                onChange={handleChangeAuthor}
                disabled={authorEditable}
              />
              <FontAwesomeIcon
                icon={faEdit}
                style={{ marginLeft: '5px' }}
                onClick={() => setAuthorEditable(!authorEditable)}
              />
            </div>
          </Form.Group>
        </Col>
      </Row>
      <Row style={{ width: '50%', marginLeft: '0', marginRight: '15px' }}>
        <Col>
          <Form.Group className="mb-3 mt-2" controlId="authorId">
            <Form.Label className="mr-2 mb-0" style={{ fontWeight: 600 }}>
              Publisher
            </Form.Label>
            <div className="d-flex align-items-center">
              <Form.Control
                ref={inputPublisherRef}
                as="input"
                value={publisher}
                onChange={handleChangePublisher}
                disabled={publisherEditable}
              />
              <FontAwesomeIcon
                icon={faEdit}
                style={{ marginLeft: '5px' }}
                onClick={() => setPublisherEditable(!publisherEditable)}
              />
            </div>
          </Form.Group>
        </Col>
      </Row>
      <Row style={{ width: '150px', marginLeft: '0', marginRight: '15px' }}>
        <Col>
          <Form.Group className="mb-3 mt-2" controlId="titleId">
            <Form.Label className="mr-2 mb-0" style={{ fontWeight: 600 }}>
              Publication Year
            </Form.Label>
            <div className="d-flex align-items-center">
              <Form.Control ref={inputYearRef} as="input" value={year} onChange={handleChangeYear} disabled={yearEditable} />
              <FontAwesomeIcon icon={faEdit} style={{ marginLeft: '5px' }} onClick={() => setYearEditable(!yearEditable)} />
            </div>
            <Form.Control.Feedback
              type="invalid"
              style={{
                display: `${validYear ? 'none' : 'block'}`,
              }}
            >
              Please type a valid year.
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
      </Row>
      <Row style={{ width: '350px', marginLeft: '0', marginRight: '15px' }}>
        <Col>
          <Form.Group className="mb-3 mt-2" controlId="titleId">
            <Form.Label className="mr-2 mb-0" style={{ fontWeight: 600 }}>
              Publisher Location
            </Form.Label>
            <div className="d-flex align-items-center">
              <Form.Control
                ref={inputLocationRef}
                as="input"
                value={location}
                onChange={handleChangeLocation}
                disabled={locationEditable}
              />
              <FontAwesomeIcon
                icon={faEdit}
                style={{ marginLeft: '5px' }}
                onClick={() => setLocationEditable(!locationEditable)}
              />
            </div>
          </Form.Group>
        </Col>
      </Row>
      <Row style={{ width: '50%', marginLeft: '0', marginRight: '15px' }}>
        <Col>
          <Form.Group className="mb-3 mt-2" controlId="description">
            <Form.Label className="mr-2 mb-0" style={{ fontWeight: 600 }}>
              Description
            </Form.Label>
            <div className="d-flex align-items-center">
              <Form.Control
                ref={inputDescRef}
                as="textarea"
                value={desc}
                rows={5}
                onChange={handleChangeDescription}
                disabled={descEditable}
              />
              <FontAwesomeIcon icon={faEdit} style={{ marginLeft: '5px' }} onClick={() => setDescEditable(!descEditable)} />
            </div>
          </Form.Group>
          <Form.Control.Feedback
            type="invalid"
            style={{
              display: `${validDesc ? 'none' : 'block'}`,
            }}
          >
            Please type a description.
          </Form.Control.Feedback>
        </Col>
      </Row>
      <div className="flex mt-2 ml-3 items-center">
        {document?.externalUrl !== undefined ? (
          <></>
        ) : (
          <div style={{ display: 'flex' }}>
            {(document?.state === 'IN_REVIEW' ||
              document?.state === 'REVIEWING' ||
              document?.state === 'PENDING' ||
              document?.state === 'PUBLISHED' ||
              document?.state === 'READY') &&
              (updatingText ||
              (buttonStatus &&
                buttonStatusTitle &&
                buttonStatusDesc &&
                buttonStatusYear &&
                buttonStatusAuth &&
                buttonStatusPublisher &&
                selectedMp3 === null &&
                buttonStatusLoc) ? (
                <Button type="success" className="update-button" disabled={true} onClick={onUpdate}>
                  {updatingText && (
                    <Spinner
                      as="span"
                      animation="grow"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      style={{ marginRight: '4px' }}
                    />
                  )}
                  Update
                </Button>
              ) : (
                <Button type="success" className="update-button" disabled={false} onClick={onUpdate}>
                  {updatingText && (
                    <Spinner
                      as="span"
                      animation="grow"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      style={{ marginRight: '4px' }}
                    />
                  )}
                  Update
                </Button>
              ))}
            <Button
              variant="light"
              className="flex items-center ml-4"
              onClick={() => setIsExpanded((prevState) => !prevState)}
              style={{ height: '40px' }}
            >
              <span className="mr-4">Voice settings</span>
              <ArrowIcon />
            </Button>
          </div>
        )}
        <Button
          variant="light"
          className="flex items-center ml-4"
          onClick={() => setIsCopyExpanded((prevState) => !prevState)}
          style={{ height: '40px' }}
        >
          <span className="mr-4">Copy Episode</span>
          <ArrowIconCopyDoc />
        </Button>
      </div>

      {document.speechParams?.languageCode && voiceSettings.length > 0 && isExpanded && (
        <div>
          {document?.speechParams?.languageCode === responseLanguage && (
            <div className="mt-2">
              <span className="font-weight-bold">{`Your selected language is ${document?.language}-${document?.speechParams?.languageCode}`}</span>
            </div>
          )}
          <div className="flex mt-3">
            <div className="mr-2">
              <Form.Control
                as="select"
                ref={languageVoiceRef}
                defaultValue={
                  responseLanguage !== undefined && document?.speechParams?.languageCode
                    ? document?.speechParams?.languageCode
                    : ''
                }
                onChange={(e) => {
                  setResponseLanguage(e.target.value);
                  const item = voices[e.target.value];
                  setVoiceSettings(item);
                }}
              >
                <option value={'en-GB'}>English GB</option>
                <option value={'en-US'}>English US</option>
                <option value={'ja-JP'}>Japanese</option>
                <option value={'zh-CN'}>Chinese</option>
                <option value={'es-ES'}>Spanish European</option>
                <option value={'es-MX'}>Spanish Mexican</option>
                <option value={'es-US'}>Spanish US</option>
              </Form.Control>
            </div>
            <div className="mr-2">
              <Form.Control
                as="select"
                ref={voiceIdRef}
                defaultValue={responseLanguage !== undefined && voiceSettings.length > 0 ? voiceSettings[0].voiceId : ''}
                onChange={(e) => {
                  const languageCode = responseLanguage!;
                  const voiceItem = voices[languageCode];
                  const filteredItem = voiceItem.filter((item) => item.voiceId === e.target.value);
                  console.log('filteredItem', filteredItem, typeof filteredItem);
                  setVoiceSettings(filteredItem);
                  setVoiceValues((prevState) => {
                    return { ...prevState, voiceId: filteredItem[0].voiceId };
                  });
                }}
              >
                {responseLanguage &&
                  voices[responseLanguage]?.map((item) => (
                    <option key={`${item.voiceId} - ${item.provider}`} value={item.voiceId}>
                      {item.provider}: {item.voiceId} - {item.gender}
                    </option>
                  ))}
              </Form.Control>
            </div>
            <div className="mr-2">
              <Form.Control
                as="select"
                ref={enginesRef}
                onChange={(e) => {
                  setVoiceValues((prevState) => {
                    return { ...prevState, engine: e.target.value };
                  });
                }}
              >
                {voiceSettings[0]['engines']?.map((value) => (
                  <option key={value} value={value}>
                    {value}
                  </option>
                ))}
              </Form.Control>
            </div>

            <div style={{ display: 'block' }}>
              <Form.Control
                as="select"
                ref={domainsRef}
                defaultValue={
                  document?.speechParams?.domain && document?.speechParams?.domain === ''
                    ? 'empty'
                    : document?.speechParams?.domain
                }
                onChange={(e) => {
                  setVoiceValues((prevState) => {
                    return { ...prevState, domain: e.target.value };
                  });
                }}
                onLoad={() => {}}
              >
                {voiceSettings[0]['domains']?.map((value) => (
                  <option key={value} value={value}>
                    {value}
                  </option>
                ))}
                {voiceSettings[0]['domains']?.length === 0 ||
                  (document?.speechParams?.domain === '' && (
                    <option key={`domain-empty`} value="empty">
                      empty
                    </option>
                  ))}
              </Form.Control>
            </div>
          </div>
          <div className="mt-3">
            <label className="block text-gray-800 font-bold md:text-right mb-1 md:mb-0 pr-4">prosodyRate:</label>
            <Form.Control
              as="select"
              ref={speakingRateRef}
              className="w-25 mt-1"
              defaultValue={document?.speechParams?.prosodyRate}
              onChange={(e) => {
                setVoiceValues((prevState) => {
                  return { ...prevState, prosodyRate: parseInt(e.target.value) };
                });
              }}
            >
              {prosodyRateValues.map((value) => (
                <option key={value} value={value}>
                  {value}
                </option>
              ))}
              {prosodyRateValues.filter((item) => item === document?.speechParams?.prosodyRate).length === 0 && (
                <option key={document?.speechParams?.prosodyRate} value={document?.speechParams?.prosodyRate}>
                  {document?.speechParams?.prosodyRate}
                </option>
              )}
            </Form.Control>
          </div>
          <div className="mt-3">
            <Button
              type="success"
              className="update-button"
              disabled={voiceBtnDisabled || voiceUpdating}
              onClick={onUpdateVoiceSettings}
            >
              {voiceUpdating && (
                <Spinner
                  as="span"
                  animation="grow"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  style={{ marginRight: '4px' }}
                />
              )}
              Update Voice Settings
            </Button>
          </div>
          {voiceAlert.show && (
            <Alert
              style={{ bottom: '120px' }}
              variant={voiceAlert.variant}
              dismissible
              onClose={() => setVoiceAlert({ show: false, variant: 'danger', message: '' })}
            >
              {voiceAlert.message}
            </Alert>
          )}
        </div>
      )}

      {isCopyExpanded && (
        <div>
          <Form>
            <div className="mt-5">
              <Row className="justify-content-between align-items-center">
                <Col>
                  <label htmlFor="documentId">Document ID</label>
                  <InputGroup className="mb-3" style={{ width: '50%' }}>
                    <FormControl ref={documentId} />
                    <InputGroup.Append>
                      <Button variant="info" onClick={generateUID}>
                        Generate UID
                      </Button>
                    </InputGroup.Append>
                    <Form.Control.Feedback
                      type="invalid"
                      style={{
                        display: `${reqvaluedocId || validated ? 'block' : 'none'}`,
                      }}
                    >
                      Please insert a valid UID or press the button Generate a random one.
                    </Form.Control.Feedback>
                  </InputGroup>
                  <Form.Group controlId="customerId" style={{ width: '50%' }}>
                    <Form.Label>Customer ID</Form.Label>
                    <Form.Control as="select" ref={customerId} onChange={handleCustomerOnChange}>
                      <option value={0}></option>
                      {podcasts !== undefined &&
                        podcasts?.length > 0 &&
                        !process?.env?.REACT_APP_TABS?.includes('NONE') &&
                        sortPodcastIdArray()?.map(
                          (c: {
                            id: string | number | readonly string[] | undefined;
                            title: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal | null | undefined;
                          }) => (
                            <option key={c.id?.toString()} value={c.id}>
                              {c.id}
                            </option>
                          ),
                        )}
                      {process?.env?.REACT_APP_TABS?.includes('NONE') &&
                        customerIds.map((c) => (
                          <option key={c.toString()} value={c}>
                            {c}
                          </option>
                        ))}
                    </Form.Control>
                    <Form.Control.Feedback
                      type="invalid"
                      style={{
                        display: `${reqvaluecustId ? 'block' : 'none'}`,
                      }}
                    >
                      Please select a Customer.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
            </div>
          </Form>
          <div className="mt-3">
            <Button type="success" className="update-button" disabled={copyInProgress} onClick={onCopyDocument}>
              {copyInProgress && (
                <Spinner
                  as="span"
                  animation="grow"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  style={{ marginRight: '4px' }}
                />
              )}
              Copy document
            </Button>
          </div>
        </div>
      )}
      <Modal
        open={openMp3Modal}
        onClose={handleCloseMp3Modal}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <Box className="modal-wrapper">
          <Box className="modal-header">
            <Box className="title">Upload File</Box>
          </Box>
          <ModalBody>
            {uploadingMp3 && (
              <div>
                <p style={{ marginBottom: '10px', fontSize: '18px' }}>{`Your file is uploading...`}</p>
                <ProgressBar animated now={100} style={{ width: '100%' }} />
              </div>
            )}
            {!uploadingMp3 && (
              <div>
                <p style={{ fontSize: '18px' }}>{`Upload finished!`}</p>
              </div>
            )}
          </ModalBody>
          <ModalFooter>
            <Button disabled={uploadingMp3} variant="danger" onClick={handleCloseMp3Modal}>
              Close
            </Button>
          </ModalFooter>
        </Box>
      </Modal>
      <HistoryModal
        openHistoryModal={openHistoryModal}
        historyAudio={document?.audioGenerations}
        historyDocument={document?.documentRevisions}
        closeHistoryModal={() => setOpenHistoryModal(false)}
      />
      <ConfirmationModal
        show={showModalConfirmation}
        discardAction={onModalToggle}
        confirmAction={onConfirmationDelete}
        action={'delete'}
      />
    </Content>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    documents: state.documents.documents,
    error: state.documents.error,
    message: state.documents.message,
    loading: state.documents.loading,
  };
};

const dispatchToProps: DispatchProps = {
  startFetchingDocument,
  startPublishingDocument,
  startUpdatingDocument,
  fetchedDocument,
};

export default connect(mapStateToProps, dispatchToProps)(withRouter(Document));
